import { CaseResourceType } from '@/api/apis/case';
import { LogisticsResourceWithFallback } from '@/types/route';
import { RouteResourceDevice } from './RouteResourceDevice';
import { SuggestedResourceRS } from './SuggestedResourceRS';
import { SuggestedResourceCS } from './SuggestedResourceCS';

type RouteResourceProps = {
  suggestedRouteId: string;
  resource: LogisticsResourceWithFallback;
  orTimeUTC: string;
};

export const RouteResource = ({ suggestedRouteId, resource, orTimeUTC }: RouteResourceProps) => {
  switch (resource.resourceType) {
    case CaseResourceType.Surgeon:
      return (
        <SuggestedResourceRS
          suggestedRouteId={suggestedRouteId}
          resourceId={resource.resourceId}
          fallbackInfo={resource.fallbackInfo}
          orTimeUTC={orTimeUTC}
        />
      );
    case CaseResourceType.ClinicalSpecialist:
      return (
        <SuggestedResourceCS
          suggestedRouteId={suggestedRouteId}
          resourceId={resource.resourceId}
          fallbackInfo={resource.fallbackInfo}
          orTimeUTC={orTimeUTC}
        />
      );
    case CaseResourceType.OCSConsole:
      return <RouteResourceDevice suggestedRouteId={suggestedRouteId} resource={resource} />;
    default:
      return null;
  }
};
